import React, { Dispatch, SetStateAction } from "react";

import { useGetFields } from "utils";

import { CropMixComposerOverlay } from "pages/app/crop-mix-composer/CropMixComposerOverlay.tsx";

export const CropMixComposer = ({
  visible,
  setShowCropMixComposer,
  regionId,
  openInDrawer,
  fieldId,
}: {
  visible: boolean;
  setShowCropMixComposer?: Dispatch<SetStateAction<boolean>>;
  regionId?: string;
  openInDrawer?: boolean;
  fieldId?: string;
}) => {
  const { data: fields } = useGetFields({ enabled: !openInDrawer });
  const activeRegionId = openInDrawer || regionId ? regionId : fields?.[0]?.regionId;

  return (
    <CropMixComposerOverlay
      visible={visible}
      regionId={activeRegionId}
      setShowCropMixComposer={setShowCropMixComposer}
      openInDrawer={openInDrawer}
      fieldId={fieldId}
    />
  );
};
